export default "__VITE_ASSET__Wg3MrSWN__"